import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DestaqueSemanaService, DestaqueSemanaDto } from './destaque-semana.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-destaques-semana-list',
  templateUrl: './destaques-semana-list.component.html',
  styleUrls: ['./destaques-semana-list.component.css']
})
export class DestaquesSemanaListComponent implements OnInit {
  loading = false;
  page = 1;
  pageSize = 20;
  total = 0;

  filtroAtivo = '';
  items: DestaqueSemanaDto[] = [];

  constructor(
    private svc: DestaqueSemanaService,
    private notify: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    const isActive = this.filtroAtivo === '' ? undefined : this.filtroAtivo === 'true';
    this.svc.list(this.page, this.pageSize, isActive).subscribe({
      next: (res: any) => {
        this.items = res?.data ?? (Array.isArray(res) ? res : []);
        this.total = res?.meta?.total ?? this.items.length;
        this.loading = false;
      },
      error: (err) => {
        console.error('[DestaquesSemana] erro ao listar', err);
        this.notify.showError('Erro ao carregar destaques da semana');
        this.loading = false;
      }
    });
  }

  resetFilters(): void {
    this.filtroAtivo = '';
    this.page = 1;
    this.load();
  }

  onPageChange(p: number): void {
    this.page = p;
    this.load();
  }

  edit(item: DestaqueSemanaDto): void {
    this.router.navigate(['/admin/destaques-semana', item.id, 'edit']);
  }

  remove(item: DestaqueSemanaDto): void {
    if (!confirm('Remover este destaque da semana?')) return;
    this.svc.delete(item.id).subscribe({
      next: () => {
        this.notify.showSuccess('Destaque removido');
        this.load();
      },
      error: (err) => {
        console.error('[DestaquesSemana] erro ao remover', err);
        this.notify.showError('Erro ao remover destaque');
      }
    });
  }

  displayEnd(): number {
    const end = this.page * this.pageSize;
    return end > this.total ? this.total : end;
  }
}
